<template>
  <div
    class="navWrap"
    :class="[getBdg(gray), getBdgTenant(gray)]"
    :style="{ top: '0px', position: pos }"
    style="display: flex"
  >
    <div class="navCon clear">
      <u-connect-activation-alert/>
      <!--logo-->
      <el-row style="display: flex; align-items: center">
        <el-col :span="11" :offset="1">
          <div
            class="logo"
            @click="privateMode ? null : redirectToHome()"
          ></div>
        </el-col>

        <el-col v-if="!privateMode && isModeVisible()" :span="1">
          <div class="onOff" @click="turn" v-bind:class="{ on: mode == 'on' }">
            <div class="circle">
              <span v-if="mode == 'off'">OFF</span
              ><span v-if="mode == 'on'">ON</span>
            </div>
            <div class="text">Mode</div>
          </div>
        </el-col>


<!--        <el-col v-if="!privateMode && isModeVisible()" :span="4"  type="flex" justify="center" class="toggle-container">-->
<!--          <span>Commission Mode</span>-->
<!--          <el-switch-->
<!--            v-model="mode"-->
<!--            @change="turn"-->
<!--            active-text=""-->
<!--            inactive-text=""-->
<!--            active-color="#0f8383"-->
<!--            inactive-color="#d3d3d3"-->
<!--          />-->
<!--        </el-col>-->

        <el-col
          v-if="!privateMode"
          :span="11"
          style="display: flex; justify-content: flex-end"
        >
          <!--nav-->
          <!--          <div class="nav">-->
          <!--            <ul>-->
          <!--              <li v-if="isSignedIn" @click="toMyAccount">My Account</li>-->
          <!--              <li v-if="!isSignedIn" @click="toLogin">Login</li>-->
          <!--            </ul>-->
          <!--          </div>-->
          <el-menu
            :default-active="activeIndexPage"
            class="el-menu-demo"
            mode="horizontal"
            @select="handleNavigation"
            text-color="#003333"
            active-text-color="#003333"
          >
<!--            <el-menu-item index="buy" v-if="!privateMode">Buy</el-menu-item>-->
<!--            <el-menu-item index="sold"  v-if="!privateMode">Sold</el-menu-item>-->
            <el-menu-item index="blog" v-if="!privateMode">Blog</el-menu-item>
<!--            <el-menu-item index="how-it-works">How it works</el-menu-item>-->
<!--            <el-submenu index="about-us">-->
<!--              <template slot="title">About Us</template>-->
<!--            <el-menu-item index="about-us">About Us</el-menu-item>-->

<!--            </el-submenu>-->

            <el-submenu index="user-account" v-if="isSignedIn && !privateMode">
              <template slot="title">
                Welcome <b>{{ firstName }}</b>
              </template>
              <el-menu-item index="my-account" >My Account</el-menu-item>
              <el-menu-item index="logout">Logout</el-menu-item>
            </el-submenu>
<!--            <el-menu-item index="my-account" v-if="isSignedIn && !privateMode"-->
<!--              >My Account-->
<!--            </el-menu-item>-->
<!--            <el-menu-item index="logout" v-if="isSignedIn && !privateMode">-->
<!--              <el-button class="menu-item-btn" >Logout</el-button>-->
<!--            </el-menu-item>-->
            <el-menu-item index="login" v-if="!isSignedIn && !privateMode">
              <el-button class="menu-item-btn" >Login</el-button>
            </el-menu-item>
<!--            <el-menu-item index="join" v-if="!isSignedIn"-->
<!--                          style="background-color: #003333; color: #ffffff;-->
<!--                          border-radius: 0 25px 0 0; padding-left: 30px; padding-right: 30px; max-height: 45px">Join</el-menu-item>-->
          </el-menu>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import Cookies from 'js-cookie';
import {isTokenExpired} from "../../untils/authTokenUtils";
import UConnectActivationAlert from "../uConnect/alert/uconnectActivationAlert.vue";

export default {
  components: {UConnectActivationAlert},
  inject: ["reload"],

  data() {
    return {
      excludePaths:['/uConnectLogin','/login','/privatelogin', '/how-it-works', '/about','/contactus', '/terms-and-conditions', '/blog', 'privacy-policy', '/uConnectRegister'],
      blogPostPaths: ['/blog/'],
      activeIndex2: "1",
      isDarkTheme: false,
      mode: "off",
      urlLst: [],
      isSignedIn: false,
      firstName: "",
      user: "",
      searchFiltersForm: {
        sort: "time",
        saleType: "1",
        propertyTypeList: ["All"],
        minPrice: "Any",
        maxPrice: "Any",
        minRentalEstimate: "Any",
        maxRentalEstimate: "Any",
        minLandSize: "Any",
        maxLandSize: "Any",
        minBuildSize: "Any",
        maxBuildSize: "Any",
        minBedrooms: "Any",
        maxBedrooms: "Any",
        bathrooms: "Any",
        carSpaces: "Any",
        searchSuburb: ""
      },
      adminRolePermission: '',
    };
  },
  props: {
    gray: {
      type: Boolean,
      default: () => {
        return false;
      }
    },
    pos: {
      type: String,
      default: () => {}
    },
    activeIndexPage: {
      type: String,
      default: () => {
        return ""
      }
    },
    isUConnectSignIn: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    privateMode:{
      type: Boolean,
      default: () => {
        return false
      }
    },
  },
  created() {
    var that = this;
    if (localStorage.getItem("mode")) {
      that.mode = localStorage.getItem("mode");
    }

    // only for private mode view property page Header
    if (
      this.$route.path == "/private/uconnect/view" &&
      sessionStorage.getItem("psd") !== null &&
      sessionStorage.getItem("psd") !== "" &&
      sessionStorage.getItem("psd") !== undefined
    ) {
      // check the psd token
      that.getPropertyDtl2({
        params: {
          id: this.$route.query.pid,
          password: sessionStorage.getItem("psd").split("/")[0],
          publicFlag: sessionStorage.getItem("unifi_publicFlag") ? 1 : 0
        },
        callback: that.callback
      });
    }
    if (!this.privateMode) {
      const authToken =localStorage.getItem("token")
      if(authToken || !isTokenExpired(authToken)){
        that.isSignedIn = true;
        that.firstName = localStorage.getItem("firstName");
      }
      // if (!this.excludePaths.includes(this.$route.path)) {
      //   this.getAgentName({callback: this.userCallback});
      // }
    }
  },
  beforeMount() {
    if (!this.privateMode) {
      this.getPermission({params: {}, callback: this.permissionCallback});
    }
  },
  methods: {
    ...mapMutations(["change"]),
    ...mapActions(["getAgentName", "getPropertyDtl2","logOut", "getPermission"]),
    handleNavigation(key, keyPath) {
      var that = this;
      switch (key) {
        case "about-us":
          that.$router.push("/about");
          break;
        case "how-it-works":
          that.$router.push("/how-it-works");
          break;
        case "my-account":
          if (that.$route.path !== "/profile") {
            that.$router.push("/profile");
          } else {
            that.reload();
          }
          break;
        case "login":
          if (that.$route.path !== "/login") {
            that.$router.push("/login");
          } else {
            that.reload();
          }
          break;
        case "logout":
          this.getLogOut();
          localStorage.clear();
          localStorage.clear();
          sessionStorage.clear();
          Cookies.remove('unifitoken');
          this.change({ data: "off" });
          if (that.$route.path !== "/login") {
            that.$router.push("/login");
          } else {
            that.reload();
          }

          break;
        case "blog":
          that.$router.push("/blog");
          break;
        case "buy":
          this.goToQuickSearch("buy")
          break;
        case "sold":
          this.goToQuickSearch("sold");
          break;
        default:
          break;
      }
    },

    isFreeTire() {
      var adminRole = localStorage.getItem('role');
      if (adminRole === '4') {
        if (this.adminRolePermission === 'UCON_STND_FREE'){
          localStorage.setItem("mode", "on");
          this.mode = "on";
          this.change({ data: "on" });
          console.log("turn on", this.mode);
          return true;
        }
      }else {
        return false;
      }
    },
    turn() {
      var that = this;
      if (that.mode == "off") {
        localStorage.setItem("mode", "on");
        that.mode = "on";
        that.change({ data: "on" });
        console.log("turn on", that.mode);
      } else {
        localStorage.setItem("mode", "off");
        that.mode = "off";
        that.change({ data: "off" });
        console.log("turn off", that.mode);
      }
    },
    handleNavigationClick() {
      var v = this.urlLst.find(v => {
        if (v.type == 2) {
          return v;
        }
      });
      if (v) {
        window.open(v.url, "_blank");
      }
    },
    toLogin() {
      var that = this;
      if (that.$route.path !== "/uConnectLogin") {
        that.$router.push("/uConnectLogin");
      } else {
        that.reload();
      }
    },
    toMyAccount() {
      var that = this;
      if (that.$route.path !== "/profile") {
        that.$router.push("/profile");
      } else {
        that.reload();
      }
    },
    redirectToHome() {
      //clear search text from session storage
      if (sessionStorage.searchFiltersForm) {
        let options = JSON.parse(sessionStorage.searchFiltersForm);
        options.searchSuburb = "";
        sessionStorage.setItem("searchFiltersForm", JSON.stringify(options));
      }

      var that = this;
      if (that.$route.path !== "/uconnect/search/results") {
        that.$router.push("/uconnect/search/results");
      } else if (that.privateMode) {
        that.$router.push({ path: "/privateLogin" });
      }else {
        that.$router.go();
      }
    },
    getBdg(gray) {
      if (gray) {
        return "bdg";
      }
      return "";
    },
    getBdgTenant(gray) {
      if (gray) {
        return "bdg-" + this.tenant;
      }
      return "";
    },
    getLogOut() {
      this.logOut({
        pat: {},
        callback: resp => {
          if (resp.code == 0) {
            this.msgNum = resp.data;
          }
        }
      });
    },
    userCallback(res) {
      console.log("Top Nav userCallback", res);
      var that = this;
      if (res.code == 0) {
        //res.data.data.abn = that.$box.formatAbn(res.data.data.abn)
        that.user = res.data;
        that.isSignedIn = true;
        // that.userName = that.user.firstName;
        // console.log("user",  that.user)
        // console.log("isSignedIn",  that.isSignedIn)

        sessionStorage.removeItem("a");
        sessionStorage.removeItem("b");
        sessionStorage.removeItem("c");
        sessionStorage.removeItem("d");
        sessionStorage.setItem("a", res.data.email);
        sessionStorage.setItem("b", res.data.phoneNumber);
        sessionStorage.setItem("c", res.data.mobileNumber);
        sessionStorage.setItem(
          "d",
          res.data.firstName + " " + res.data.lastName
        );
      } else if (res.code == 90000 || res.code == 90002) {
        //localStorage.clear()
        //that.$router.push('/login')
      } else if (res.code == 8902 || res.code == 8901) {
        // that.$box.alert('', res.data.message ,'error')
        //localStorage.clear()
        //that.$router.push('/login')
      }
    },
    permissionCallback(res) {
      console.log("top nav: save - callback ", res);
      if (res.code === 0) {
        this.adminRolePermission = res.data.rolePermission;
      } else if (res.code === 90000 || res.code === 90002 || res.code === 90001) {
        localStorage.clear()
        that.$router.push('/login')
      } else if (res.code === 8902 || res.code === 8901) {
        that.$box.alert('', res.data.message, 'error')
        localStorage.clear()
        that.$router.push('/login')
      } else if (res.code === 20001) {
        that.$router.push('/')
      } else {
        that.$box.alert('', res.message, 'error')
      }
    },
    callback(res) {
      console.log("top nav: save - callback ", res);
      if (res.code === 0) {
        console.log("top nav: save - callback ", res);
        this.privateMode = true;
      } else if (res.code === 400004) {
        console.log("top nav: save - callback B", res);
        Utils.alert("", res.message, "error");
        sessionStorage.removeItem(sessionStorage.getItem("unifi_pid"));
        sessionStorage.removeItem("psd");
        this.$router.push({ path: "/privateLogin" });
      } else {
        console.log("top nav: save - callback C", res);
        Utils.alert("", res.message, "error");
        sessionStorage.removeItem(sessionStorage.getItem("unifi_pid"));
        sessionStorage.removeItem("psd");
        this.$router.push({ path: "/privateLogin" });
      }
    },
    goToQuickSearch(selectedPropertyType) {
      //get for SA only for now, and fix up post go live

      let options = sessionStorage.searchFiltersForm
        ? JSON.parse(sessionStorage.searchFiltersForm)
        : this.searchFiltersForm;



      // this.searchFiltersForm.searchType = this.searchType
      if (options.searchSuburb) {
        options.searchSuburb.replace(
          " SA, Australia",
          ""
        );
      }
      //set search Property Type
      if(selectedPropertyType === 'sold'){
        options.searchType = "sold";
      }else{
        options.searchType = "buy";
      }
      sessionStorage.setItem("isSearch", "1");
      sessionStorage.setItem(
        "searchFiltersForm",
        JSON.stringify(options)
      );
      if (this.$route.path !== "/uconnect/search/results") {
        this.$router.push("/uconnect/search/results");
      } else {
        this.$router.go();
      }
    },
    isModeVisible() {
      console.log("test", this.$route.path === "/uconnect/search/results" || this.$route.path === "/uconnect/view");
      return (this.$route.path === "/uconnect/search/results" || this.$route.path === "/uconnect/view") && !this.isFreeTire();
    }
  },
  computed: {}
};
</script>

<style scoped>
.el-menu-demo {
  background-color: transparent;
  color: #003333;
  font-family: DINosaur-a, sans-serif;

}
.navWrap {
  width: 100%;
  height: 90px;
  min-width: 1200px;
  position: absolute;
  left: 0;
  top: 0;
  transition: background-color 0.5s;
  z-index: 11;
  padding: 7px 0px 7px 0px;
  background-color: transparent;
}

.navCon {
  width: 1860px;
  margin: auto auto;

  .logo {
    width: 300px;
    height: 50px;
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    background-image: url("../../assets/unifi-logo-new-with-text-green.svg");
    float: left;
    cursor: pointer;
  }
  .toggle {
    .switch {
      position: relative;
      display: inline-block;
      width: 60px;
      height: 34px;
    }

    .switch input {
      display: none;
    }
    p {
      display: inline-block;
      vertical-align: middle;
      padding-right: 5px;
    }

    .slider {
      position: absolute;
      cursor: pointer;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: #ccc;
      -webkit-transition: 0.4s;
      transition: 0.4s;
    }

    .slider:before {
      position: absolute;
      content: "";
      height: 26px;
      width: 26px;
      left: 4px;
      bottom: 4px;
      background-color: white;
      -webkit-transition: 0.4s;
      transition: 0.4s;
    }

    input:checked + .slider:before {
      -webkit-transform: translateX(26px);
      -ms-transform: translateX(26px);
      transform: translateX(26px);
    }

    .slider.round {
      border-radius: 34px;
    }

    .slider.round:before {
      border-radius: 50%;
    }
  }
  .nav {
    float: right;
    color: #003333;
    li {
      float: left;
      margin-right: 24px;
      cursor: pointer;
      font-family: DINusr-a;
      font-size: 18px;
      font-style: normal;
      font-weight: 700;
      line-height: 20px;
      position: relative;
      a {
        color: #fff;
        text-decoration: none;
      }
      i {
        position: absolute;
        left: -21px;
        top: 10px;
        display: block;
        width: 20px;
        height: 20px;
        background-size: 20px 20px;
        background-position: left center;
        background-repeat: no-repeat;
        background-image: url("../../assets/logoUNIWhite.png");
      }
    }
    li:nth-last-child(1) {
      margin-right: 0;
    }
  }
}
.nav ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
  background-color: #101010;
  display: flex;
  justify-content: space-between;
}

.nav li {
  display: flex;
  align-items: center;
  color: white;
  padding: 0 20px;
}

.toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 180px;
}

.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
  transform: scale(0.5);
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #ffffff;
}

input:focus + .slider {
  box-shadow: 0 0 1px #ffffff;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

.dark-switch {
  background-color: #ffffff;
}

.light-switch {
  background-color: #101010;
}

.onOff {
  width: 127px;
  height: 32px;
  border: 1px solid #003333;
  color: #003333;
  border-radius: 16px;
  box-sizing: border-box;
  margin-top: 10px;
  float: right;
  margin-right: 63px;
  position: relative;
  cursor: pointer;
  .circle {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: #003333;
    position: absolute;
    right: 1px;
    top: 1px;
    font-size: 8px;
    color: #ffffff;
    line-height: 28px;
    text-align: center;
    transition: all 0.5s;
    font-family: DINosaur-a, sans-serif;
  }
  .text {
    margin-left: 40px;
    line-height: 30px;
    font-size: 12px;
    transition: all 0.5s;
    font-family: DINosaur-a, sans-serif;
  }
}
.on {
  .circle {
    right: 96px;
  }
  .text {
    margin-left: 52px;
  }
}
.el-menu-item,
.el-submenu /deep/ .el-submenu__title {
  font-family: DINosaur-a;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
}
.el-menu.el-menu--horizontal {
  border-bottom: none;
}

.menu-item-btn{
  background-color: #003333;
  color: #ffffff;
  border-radius: 5px;
  padding-left: 30px;
  padding-right: 30px;
  max-height: 45px;
  font-family: DINosaur-a;
  font-size: 18px;
  font-weight: 400;
  border-color: #003333;
}

/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  .el-menu-item,
  .el-submenu /deep/ .el-submenu__title {
    font-size: 8px;
    font-weight: 400;
  }
  .menu-item-btn{
    padding-left: 10px;
    padding-right: 10px;
    max-height: 35px;
    font-size: 8px;
  }
}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {
  .el-menu-item,
  .el-submenu /deep/ .el-submenu__title {
    font-size: 8px;
    font-weight: 400;
  }
  .menu-item-btn{
    padding-left: 10px;
    padding-right: 10px;
    max-height: 35px;
    font-size: 8px;
  }
}

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
  .el-menu-item,
  .el-submenu /deep/ .el-submenu__title {
    font-size: 10px;
    font-weight: 400;
  }
  .menu-item-btn{
    padding-left: 10px;
    padding-right: 10px;
    max-height: 40px;
    font-size: 10px;
  }
}

/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
  .el-menu-item,
  .el-submenu /deep/ .el-submenu__title {
    font-size: 10px;
    font-weight: 400;
  }
  .menu-item-btn{
    padding-left: 10px;
    padding-right: 10px;
    max-height: 40px;
    font-size: 10px;
  }
}
/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
  .el-menu-item,
  .el-submenu /deep/ .el-submenu__title {
    font-size: 12px;
    font-weight: 400;
  }
  .menu-item-btn{
    padding-left: 15px;
    padding-right: 15px;
    max-height: 40px;
    font-size: 12px;
  }
}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1460px) {
  .el-menu-item,
  .el-submenu /deep/ .el-submenu__title {
    font-size: 14px;
    font-weight: 400;
  }
  .menu-item-btn{
    padding-left: 20px;
    padding-right: 20px;
    max-height: 40px;
    font-size: 14px;
  }
}

@media only screen and (min-width: 1630px) {
  .el-menu-item,
  .el-submenu /deep/ .el-submenu__title {
    font-size: 18px;
    font-weight: 400;
  }
  .menu-item-btn{
    padding-left: 30px;
    padding-right: 30px;
    max-height: 45px;
    font-size: 18px;
  }
}

.toggle-container {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/package/topNav.vue